const nft = {
  "lvl00-bg":  [
      "lvl0-bg-fandy.png",
      "lvl00-bg-default-1.png",
      "lvl00-bg-default-2.png",
      "lvl00-bg-default-3.png",
      "lvl00-bg-default-4 copia.png",
      "lvl00-bg-default-4.png",
      "lvl00-bg-default-5.png",
      "lvl00-bg-default-6.png",
      "lvl00-bg-default-7.png",
      "lvl00-bg-vuitton.png",
      "lvl00-bg.png"
    ]
  ,
  "lvl07-eye":  [
      "lvl07-eye-3d.png",
      "lvl07-eye-carrera-white.png",
      "lvl07-eye-carrera.png",
      "lvl07-eye-clubmaster.png",
      "lvl07-eye-confused.png",
      "lvl07-eye-cry.png",
      "lvl07-eye-cucumber.png",
      "lvl07-eye-default.png",
      "lvl07-eye-heartsglass.png",
      "lvl07-eye-hippie.png",
      "lvl07-eye-holographic.png",
      "lvl07-eye-monocle.png",
      "lvl07-eye-nightmask.png",
      "lvl07-eye-piatepatch.png",
      "lvl07-eye-potter.png",
      "lvl07-eye-rainbow.png",
      "lvl07-eye-robocop.png",
      "lvl07-eye-skiiglass.png",
      "lvl07-eye-star-sunglasses.png",
      "lvl07-eye-thug-life.png",
      "lvl07-eye-trigghered.png",
      "lvl07-eye-wayfarer copia.png",
      "lvl07-eye-wayfarer.png",
      "lvl07-eye-willywonka.png",
      "lvl07-eyes-demon.png"
    ]
  ,
  "lvl08-mouth-closed":  [
      "lvl08-mouth-closed-beardbabbo.png",
      "lvl08-mouth-closed-beardconfucio.png",
      "lvl08-mouth-closed-bubblegum.png",
      "lvl08-mouth-closed-chinesebeard.png",
      "lvl08-mouth-closed-cigaret.png",
      "lvl08-mouth-closed-clown.png",
      "lvl08-mouth-closed-default.png",
      "lvl08-mouth-closed-lips-pink.png",
      "lvl08-mouth-closed-lips-red.png",
      "lvl08-mouth-closed-mask.png",
      "lvl08-mouth-closed-mustache.png",
      "lvl08-mouth-closed-pipe.png",
      "lvl08-mouth-closed-wheat.png",
      "lvl08-mouth-open-clown.png"
    ]
  ,
  "lvl08-mouth-open":  [
      "lvl08-mouth-open-default.png",
      "lvl08-mouth-open-gum.png",
      "lvl08-mouth-open-mustache.png",
      "lvl8-mouth-closed-saber-tooth.png",
      "lvl8-mouth-closed-splif.png",
      "lvl8-mouth-open-roar.png"
    ]
  ,
  "lvl10-chest":  [
      "lvl010-chest-matrix.png",
      "lvl10-chest-default.png",
      "lvl10-chest-pimpcoat.png"
    ]
  ,
  "lvl11-neck":  [
      "lvl11-neck-bandana.png",
      "lvl11-neck-chain-ball.png",
      "lvl11-neck-chain-BTC.png",
      "lvl11-neck-chain-dollar copia.png",
      "lvl11-neck-chain-dollar.png",
      "lvl11-neck-chain-emerald.png",
      "lvl11-neck-chain-rubin.png",
      "lvl11-neck-chain-saphire.png",
      "lvl11-neck-chain.png",
      "lvl11-neck-chocker-circles-rubber.png",
      "lvl11-neck-collare-Borchiato.png",
      "lvl11-neck-collare-spinato.png",
      "lvl11-neck-default.png",
      "lvl11-neck-fazzoletto.png",
      "lvl11-neck-fifi-scottish.png",
      "lvl11-neck-sating-chocker-black.png"
    ]
  ,
  "lvl12-head":  [
      "lvl12-head-bob.png",
      "lvl12-head-borsalino-hat.png",
      "lvl12-head-bowlerhat.png",
      "lvl12-head-bunny-ears.png",
      "lvl12-head-cave-helmet.png",
      "lvl12-head-che-hat.png",
      "lvl12-head-chinese-rice.png",
      "lvl12-head-cowboyhat.png",
      "lvl12-head-cylinder.png",
      "lvl12-head-default.png",
      "lvl12-head-fez.png",
      "lvl12-head-halo.png",
      "lvl12-head-marine-hat.png",
      "lvl12-head-pharaon.png",
      "lvl12-head-prussian-helmet.png",
      "lvl12-head-punkhair.png",
      "lvl12-head-roman-crown.png",
      "lvl12-head-samuraihelmet.png",
      "lvl12-head-siberianhat.png",
      "lvl12-head-snapback-bulls.png",
      "lvl12-head-snapback-ethereum.png",
      "lvl12-head-snapback-lakers.png",
      "lvl12-head-snapback-wb.png",
      "lvl12-head-snapback-wr.png",
      "lvl12-head-spinner.png",
      "lvl12-head-sushi-headband.png",
      "lvl12-head-vikinghelmet.png",
      "lvl12-head-visor.png"
    ]
  ,
  "lvl13-glove":  [
      "lvl13-glove-default.png",
      "lvl13-glove-homeless-black.png",
      "lvl13-glove-homeless-GOLD.png",
      "lvl13-glove-homeless-gray.png"
    ]
  ,
  "skins": {
    "skin-albino": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-blue": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-camo": [
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-cheeta": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-dalmata": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-default": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-gold": [
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-gucci": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-pink": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-radioactiveblue": [
        "lvl00-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl06-eye-back.png"
      ],
    "skin-radioactivegreen": [
        "lvl00-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl06-eye-back.png"
      ],
    "skin-rainbow": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-silver": [
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-sun": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-tatoo": [
        "lvl01-glow.png",
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ],
    "skin-tiger": [
        "lvl04-body.png",
        "lvl05-mouth-back-closed.png",
        "lvl05-mouth-back-open.png",
        "lvl06-eye-back.png"
      ]
    }
}

export default nft;
